import SectionTitle from "../reusable/SectionTitle";
import AnimateOnDisplay from "../reusable/AnimateOnDisplay";
import tamasha_ai_news_png from "../assets/images/portfolio/tamasha-ai-news.png";
import takhleeq_ai_png from "../assets/images/portfolio/takhleeq-ai.png";
import ai_adverts_png from "../assets/images/portfolio/ai-adverts_2.png";
import simosa_png from "../assets/images/portfolio/simosa.png";
import streamdial_png from "../assets/images/portfolio/streamdial.png";
import FlipCard from "./FlipCard";
import CustomizedTooltips from "./CustomizedTooltips";

const protfolioData = [
  {
    card: {
      colSpanClass: "laptop:col-span-3",
      aspectRatioClass: "aspect-[670/500]",
      smallHeight: "300px",
    },
    front: {
      image: takhleeq_ai_png,
      title: "منصة Takhleeq AI",
      description: "هنا حيث يلتقي الخيال مع إبداع الذكاء الاصطناعي المتقدم.",
    },
    back: {
      backgroundColor: "#111748",
      textColor: "#FFFFFF",
      title: (
        <p className="text-[#FFFFFF] text-lg mobile:text-2xl  font-black">
          <span className="text-[#FFC641]">منصة </span>
          Takhleeq AI&nbsp;
        </p>
      ),
      description: "هنا حيث يلتقي الخيال مع إبداع الذكاء الاصطناعي المتقدم.",
      paragraph:
        "منصة Takhleeq AI هي منصة ذكاء اصطناعي من الجيل التالي تعمل على إنشاء محتوى مؤثر دون عناء. ومن ضمن إمكانيات المنصة تحويل النص إلى صورة، وتوليف صوت المشاهير، وإزالة الخلفية في الحال، وتحسين الصور، والتحويلات التي تعتمد على الذكاء الاصطناعي...",
      detail: (
        <p dir="rtl">
          {
            "منصة Takhleeq AI هي منصة ذكاء اصطناعي من الجيل التالي تعمل على إنشاء محتوى مؤثر دون عناء. ومن ضمن إمكانيات المنصة تحويل النص إلى صورة، وتوليف صوت المشاهير، وإزالة الخلفية في الحال، وتحسين الصور، والتحويلات التي تعتمد على الذكاء الاصطناعي، وكلها إمكانيات مدعومة بالذكاء الاصطناعي المتقدم. وقد صُممت المنصة للتطبيقات الترفيهية والأعمال على حد سواء، حيث تقدم حلولاً إبداعية سريعة وقابلة للتطوير والتخصيص."
          }
        </p>
      ),
    },
  },
  {
    card: {
      colSpanClass: "laptop:col-span-3",
      aspectRatioClass: "aspect-[670/500]",
      smallHeight: "300px",
    },
    front: {
      image: tamasha_ai_news_png,
      title: " الإخبارية بالذكاء الاصطناعي Tamasha",

      description:
        "إعادة تعريف تصور الأخبار الرقمية باستخدام أصوات الذكاء الاصطناعي...",
    },
    back: {
      backgroundColor: "#FFFFFF",
      textColor: "#111748",
      title: (
        <p className="text-[#111748] text-lg mobile:text-2xl  font-black">
          <span className="text-[#FFC641]">
            {" "}
            الإخبارية بالذكاء الاصطناعي{" "}
            <span className="text-[#111748]">Tamasha</span>
          </span>
        </p>
      ),
      description:
        "إعادة تعريف تصور الأخبار الرقمية باستخدام أصوات الذكاء الاصطناعي والصور الرمزية",
      paragraph:
        "نحن ننشئ نشرات إخبارية مولَّدة بالذكاء الاصطناعي لوكالة Tamasha News AI وDigital Pakistan، ونجمع بين البرمجة النصية المتقدمة والصور الرمزية الشبيهة البشرية والتركيب الصوتي للذ...",
      detail: (
        <p dir="rtl">
          {
            "نحن ننشئ نشرات إخبارية مولَّدة بالذكاء الاصطناعي لوكالة Tamasha News AI وDigital Pakistan، ونجمع بين البرمجة النصية المتقدمة والصور الرمزية الشبيهة البشرية والتركيب الصوتي للذكاء الاصطناعي داخل الشركة. فبداية من القصص المحلية محدودة النطاق ووصولاً إلى مستجدات التكنولوجيا، فإن محتوانا يجذب الملايين ويعيد رسم التصور بشأن الأخبار الرقمية من خلال إنتاجنا القابل للتطوير والمعتمد على الذكاء الاصطناعي."
          }{" "}
        </p>
      ),
    },
  },
  {
    card: {
      colSpanClass: "laptop:col-span-2",
      aspectRatioClass: "aspect-[670/500] laptop:aspect-[440/500]",
      smallHeight: "300px",
    },
    front: {
      image: streamdial_png,
      title: "Streamdial",
      description: "إعادة رسم طبيعة الوصول إلى الفيديو من...",
    },
    back: {
      backgroundColor: "#111748",
      textColor: "#FFFFFF",
      title: (
        <p className="text-[#FFFFFF] text-lg mobile:text-2xl  font-black">
          Streamdial
        </p>
      ),
      description:
        "إعادة رسم طبيعة الوصول إلى الفيديو من خلال البث بدون تطبيقات.",
      paragraph:
        "StreamDial هي تقنية من الجيل التالي للاستجابة الصوتية التفاعلية للفيديو، والتي تتيح للمستخدمين البث المباشر للفعاليات الرياضية والمسلسلات والموسيقى وغيرها ببساطة عن طريق طلب رمز قصير...",
      detail: (
        <p dir="rtl">
          {
            "StreamDial هي تقنية من الجيل التالي للاستجابة الصوتية التفاعلية للفيديو، والتي تتيح للمستخدمين البث المباشر للفعاليات الرياضية والمسلسلات والموسيقى وغيرها ببساطة عن طريق طلب رمز قصير. وهذه التقنية تعتمد على البنية التحتية للاتصالات، ويمكن تخصيصها لأي شركة لتقديم تجارب فيديو تفاعلية متعددة اللغات تعزز التفاعل، وتفتح تدفقات إيرادات رقمية جديدة، وتعمل بسلاسة دون الحاجة إلى تطبيقات أو بيانات خاصة"
          }
          ,
        </p>
      ),
    },
  },

  {
    card: {
      colSpanClass: "laptop:col-span-2",
      aspectRatioClass: "aspect-[670/500] laptop:aspect-[440/500]",
      smallHeight: "300px",
    },
    front: {
      image: simosa_png,
      title: "SIMOSA",
      description: "دعم ملايين المستخدمين بمحتوى تفاعلي من...",
    },
    back: {
      backgroundColor: "#FFFFFF",
      textColor: "#111748",
      title: (
        <p className="text-[#111748] text-lg mobile:text-2xl  font-black">
          SIMOSA
        </p>
      ),
      description: "دعم ملايين المستخدمين بمحتوى تفاعلي من الجيل التالي",
      paragraph:
        "نحن ننشئ محتوى متقدم قائم على الأبحاث لتطبيق Simosa بالشراكة مع Jazz، بداية من الأبراج اليومية والنصائح الصحية إلى الوصفات والشعر والنكات والاقتباسات الملهمة. صُمم المحتوى الذي نقدمه لإشراك ملايين المستخدمين",
      detail: (
        <p dir="rtl">
          {
            "نحن ننشئ محتوى متقدم قائم على الأبحاث لتطبيق Simosa بالشراكة مع Jazz، بداية من الأبراج اليومية والنصائح الصحية إلى الوصفات والشعر والنكات والاقتباسات الملهمة. صُمم المحتوى الذي نقدمه لإشراك ملايين المستخدمين، وهو لا يحفز التفاعل فحسب، بل يمكن تخصيصه بالكامل ليناسب الشركات التي تبحث عن حلول محتوى رقمي عالي الجودة وقابل للتطوير."
          }
        </p>
      ),
    },
  },
  {
    card: {
      colSpanClass: "laptop:col-span-2",
      aspectRatioClass: "aspect-[670/500] laptop:aspect-[440/500]",
      smallHeight: "300px",
    },
    front: {
      image: ai_adverts_png,
      title: "الإعلانات بالذكاء الاصطناعي",
      description: "إنشاء إعلانات بالذكاء الاصطناعي شبيهة...",
    },
    back: {
      backgroundColor: "#FFC641",
      textColor: "#111748",
      title: (
        <p className="text-[#FFFFFF] text-lg mobile:text-2xl  font-black">
          الإعلانات&nbsp;
          <span className="text-[#111748]">بالذكاء الاصطناعي</span>
        </p>
      ),
      description:
        "إنشاء إعلانات بالذكاء الاصطناعي شبيهة بصنع البشر، فتوفر الوقت وتعزز النتائج",
      paragraph:
        "ننشئ محتوى إعلاني مخصص بالكامل ومولّد بالذكاء الاصطناعي لقطاعات الأعمال والمستهلكين والقطاعات الترفيهية والمؤسسات، فنجمع بين الصور الرمزية البشرية المصنوعة بالذكاء الاصطناعي والصوت المضبوط داخليًا...",
      detail: (
        <p dir="rtl">
          {
            "ننشئ محتوى إعلاني مخصص بالكامل ومولّد بالذكاء الاصطناعي لقطاعات الأعمال والمستهلكين والقطاعات الترفيهية والمؤسسات، فنجمع بين الصور الرمزية البشرية المصنوعة بالذكاء الاصطناعي والصوت المضبوط داخليًا والمرئيات التفاعلية. تم تصميم كل عمل بحيث يُعزز التفاعل، ويقلل وقت الإنتاج ويخفض التكاليف، وبما يضمن مساعدة الشركات على توسيع نطاق تسويقها بمحتوى أكثر ذكاءً وديناميكية."
          }
        </p>
      ),
    },
  },
];

const Portfolio = () => {
  return (
    <div id="portfolio" className="bg-[#ECECF0] min-h-svh py-16 px-8-">
      {/* Header */}
      <div className="text-center space-y-10 mb-12">
        <SectionTitle
          className={"text-center font-40-to-108 bg-red-500-"}
          firstChild={
            <p
              dir="rtl"
              className="leading-none text-left- font-[300] text-[#111748] uppercase"
            >
              ملفنا
            </p>
          }
          secondChild={
            <p
              dir="rtl"
              className="text-right- font-[900] leading-none text-[#111748] uppercase"
            >
              التعريفي
            </p>
          }
          viewPortStartPointFromBottom={0}
          viewPortEndPointFromBottom={50}
          firstChildTranslateAtStart={window.innerWidth * 0.3}
        />
        <AnimateOnDisplay
          animationClass={"paragraph-animation"}
          screenPercentHeightToStartAnimation={90}
          className={"opacity-0"}
          animateEveryTime={false}
        >
          <p
            dir="rtl"
            className="text-[16px] tablet:text-[22px] laptop:text-[28px] desktop:text-[34px] font-[200] text-center mx-[10%] laptop:mx-[13.33%]"
          >
            <span className="font-medium"> نتمتع بـ 13 عامًا</span>
            &nbsp;من الخبرة في خدمات التشغيل، ومنصات الاتصالات، والرسائل،
            والخدمات الصوتية، والفوترة، وإعلانات الهاتف المحمول إلى جانب التكامل
            العميق مع مشغلي شبكات الهاتف المحمول والشبكة التي.&nbsp;
            <span className="font-medium">تتعامل معها.</span>
          </p>
        </AnimateOnDisplay>
      </div>

      <div
        dir="rtl"
        className="mx-auto px-10 max-w-screen-laptop grid grid-cols-1 laptop:grid-cols-6 place-content-center gap-5"
      >
        {protfolioData.map(({ card, front, back }) => {
          const { title } = front;
          const { colSpanClass, aspectRatioClass, smallHeight } = card;
          return (
            <div key={title} className={`${colSpanClass} flex justify-center`}>
              <FlipCard
                width={aspectRatioClass ? "auto" : "100%"}
                height={window.innerWidth > 450 ? "500px" : smallHeight}
                flipOn="hover"
                className={`max-h-[50vh]- tablet:max-h-max ${aspectRatioClass} ${
                  aspectRatioClass ? "max-w-full" : ""
                }`}
                front={<PortfolioCardFront {...front} />}
                back={<PortfolioCardBack {...back} />}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Portfolio;

const PortfolioCardFront = ({ image, title, description }) => {
  return (
    <div
      className="size-full flex justify-end items-start flex-col p-4 laptop:p-7 text-white"
      style={{
        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    >
      <p
        dir="rtl"
        className="text-lg mobile:text-2xl tablet:text-3xl font-black truncate max-w-full uppercase"
        title={title}
      >
        {title}
      </p>
      <p
        dir="rtl"
        className="text-sm mobile:text-xl tablet:text-xl font-extralight text-wrap mt-1"
        title={description}
      >
        {description}
      </p>
    </div>
  );
};

const PortfolioCardBack = ({
  backgroundColor,
  textColor,
  title,
  description,
  paragraph,
  detail,
}) => {
  return (
    <div
      className="size-full px-3 pt-3 pb-6 mobile:px-5 mobile:pt-5 mobile:pb-10 tablet:px-7 tablet:pt-7 tablet:pb-12 flex flex-col justify-between"
      style={{
        backgroundColor,
        color: textColor,
      }}
    >
      <div className="space-y-6">
        <div>
          <div className="uppercase ">{title}</div>
          <p className="font-light text-sm mobile:text-base tablet:text-xl text-wrap mt-[0.2em]">
            {description}
          </p>
        </div>
        <div className="font-light text-sm mobile:text-base tablet:text-xl text-wrap select-none">
          {paragraph}
        </div>
      </div>
      <div className="w-full flex justify-center">
        <div
          className="border rounded-sm mt-2"
          style={{
            borderColor: textColor,
          }}
        >
          <CustomizedTooltips
            note={detail}
            btnText={
              <p
                style={{ color: textColor }}
                className="px-2 py-1 mobile:px-6 mobile:py-2 tablet:px-12 tablet:py-4- text-xl"
              >
                {/* <ViewDetails color={textColor} /> */}
                عرض التفاصيل
              </p>
            }
          />
        </div>
      </div>
    </div>
  );
};

// const ViewDetails = ({ color = "#111748" }) => {
//   return (
//     <svg
//       viewBox="0 0 108 15"
//       xmlns="http://www.w3.org/2000/svg"
//       style={{
//         width: "100%",
//         height: "auto",
//         maxWidth: "108px",
//         maxHeight: "15px",
//       }}
//     >
//       <path
//         opacity="0.8"
//         d="M3.53382 0.909091L6.94078 11.2131H7.07502L10.4756 0.909091H13.0835L8.46848 14H5.54093L0.932262 0.909091H3.53382ZM14.7055 14V4.18182H17.0194V14H14.7055ZM15.8689 2.78835C15.5024 2.78835 15.1871 2.6669 14.9229 2.42401C14.6586 2.17685 14.5265 1.88068 14.5265 1.53551C14.5265 1.18608 14.6586 0.889914 14.9229 0.647016C15.1871 0.399857 15.5024 0.276278 15.8689 0.276278C16.2396 0.276278 16.555 0.399857 16.8149 0.647016C17.0791 0.889914 17.2112 1.18608 17.2112 1.53551C17.2112 1.88068 17.0791 2.17685 16.8149 2.42401C16.555 2.6669 16.2396 2.78835 15.8689 2.78835ZM23.7455 14.1918C22.7611 14.1918 21.911 13.9872 21.195 13.5781C20.4834 13.1648 19.9358 12.581 19.5523 11.8267C19.1688 11.0682 18.977 10.1754 18.977 9.14844C18.977 8.13849 19.1688 7.25213 19.5523 6.48935C19.9401 5.7223 20.4813 5.12571 21.1759 4.69957C21.8705 4.26918 22.6865 4.05398 23.624 4.05398C24.2291 4.05398 24.8002 4.15199 25.3371 4.34801C25.8783 4.53977 26.3556 4.83807 26.7689 5.2429C27.1865 5.64773 27.5146 6.16335 27.7533 6.78977C27.9919 7.41193 28.1112 8.15341 28.1112 9.0142V9.72372H20.0637V8.16406H25.8932C25.8889 7.72088 25.7931 7.3267 25.6056 6.98153C25.4181 6.6321 25.156 6.35724 24.8193 6.15696C24.4869 5.95668 24.0992 5.85653 23.656 5.85653C23.183 5.85653 22.7675 5.97159 22.4095 6.2017C22.0516 6.42756 21.7725 6.72585 21.5722 7.09659C21.3762 7.46307 21.276 7.86577 21.2718 8.30469V9.66619C21.2718 10.2372 21.3762 10.7273 21.585 11.1364C21.7938 11.5412 22.0857 11.8523 22.4607 12.0696C22.8357 12.2827 23.2746 12.3892 23.7774 12.3892C24.1141 12.3892 24.4188 12.3423 24.6915 12.2486C24.9642 12.1506 25.2007 12.0078 25.401 11.8203C25.6013 11.6328 25.7526 11.4006 25.8548 11.1236L28.0154 11.3665C27.879 11.9375 27.6191 12.4361 27.2355 12.8622C26.8563 13.2841 26.3705 13.6122 25.7781 13.8466C25.1858 14.0767 24.5083 14.1918 23.7455 14.1918ZM32.0423 14L29.2682 4.18182H31.6269L33.3527 11.0852H33.4422L35.2064 4.18182H37.5395L39.3037 11.0469H39.3996L41.0999 4.18182H43.4649L40.6844 14H38.2746L36.4337 7.36506H36.2994L34.4585 14H32.0423ZM54.0837 14H49.6476V0.909091H54.1732C55.4729 0.909091 56.5894 1.17116 57.5226 1.69531C58.4601 2.2152 59.1803 2.96307 59.6832 3.93892C60.186 4.91477 60.4374 6.08239 60.4374 7.44176C60.4374 8.8054 60.1839 9.97727 59.6768 10.9574C59.1739 11.9375 58.4474 12.6896 57.4971 13.2138C56.551 13.7379 55.4133 14 54.0837 14ZM52.0191 11.9482H53.9687C54.8806 11.9482 55.6412 11.782 56.2506 11.4496C56.86 11.1129 57.3181 10.6122 57.6249 9.94744C57.9317 9.27841 58.0851 8.44318 58.0851 7.44176C58.0851 6.44034 57.9317 5.60937 57.6249 4.94886C57.3181 4.28409 56.8643 3.78764 56.2634 3.45952C55.6668 3.12713 54.9253 2.96094 54.039 2.96094H52.0191V11.9482ZM66.9349 14.1918C65.9506 14.1918 65.1004 13.9872 64.3845 13.5781C63.6729 13.1648 63.1253 12.581 62.7417 11.8267C62.3582 11.0682 62.1665 10.1754 62.1665 9.14844C62.1665 8.13849 62.3582 7.25213 62.7417 6.48935C63.1295 5.7223 63.6707 5.12571 64.3653 4.69957C65.0599 4.26918 65.876 4.05398 66.8135 4.05398C67.4186 4.05398 67.9896 4.15199 68.5265 4.34801C69.0677 4.53977 69.545 4.83807 69.9584 5.2429C70.376 5.64773 70.7041 6.16335 70.9427 6.78977C71.1814 7.41193 71.3007 8.15341 71.3007 9.0142V9.72372H63.2531V8.16406H69.0827C69.0784 7.72088 68.9825 7.3267 68.795 6.98153C68.6075 6.6321 68.3454 6.35724 68.0088 6.15696C67.6764 5.95668 67.2886 5.85653 66.8454 5.85653C66.3724 5.85653 65.9569 5.97159 65.599 6.2017C65.241 6.42756 64.9619 6.72585 64.7616 7.09659C64.5656 7.46307 64.4655 7.86577 64.4612 8.30469V9.66619C64.4612 10.2372 64.5656 10.7273 64.7744 11.1364C64.9832 11.5412 65.2751 11.8523 65.6501 12.0696C66.0251 12.2827 66.464 12.3892 66.9669 12.3892C67.3035 12.3892 67.6082 12.3423 67.8809 12.2486C68.1537 12.1506 68.3902 12.0078 68.5905 11.8203C68.7907 11.6328 68.942 11.4006 69.0443 11.1236L71.2048 11.3665C71.0684 11.9375 70.8085 12.4361 70.425 12.8622C70.0457 13.2841 69.5599 13.6122 68.9676 13.8466C68.3753 14.0767 67.6977 14.1918 66.9349 14.1918ZM78.161 4.18182V5.97159H72.5168V4.18182H78.161ZM73.9102 1.82955H76.2242V11.0469C76.2242 11.358 76.271 11.5966 76.3648 11.7628C76.4628 11.9247 76.5906 12.0355 76.7483 12.0952C76.906 12.1548 77.0807 12.1847 77.2725 12.1847C77.4173 12.1847 77.5494 12.174 77.6688 12.1527C77.7923 12.1314 77.8861 12.1122 77.95 12.0952L78.3399 13.9041C78.2164 13.9467 78.0395 13.9936 77.8094 14.0447C77.5835 14.0959 77.3066 14.1257 76.9784 14.1342C76.3989 14.1513 75.8769 14.0639 75.4124 13.8722C74.9479 13.6761 74.5793 13.3736 74.3066 12.9645C74.0381 12.5554 73.906 12.044 73.9102 11.4304V1.82955ZM82.9214 14.1982C82.2993 14.1982 81.7389 14.0874 81.2403 13.8658C80.746 13.6399 80.354 13.3075 80.0642 12.8686C79.7787 12.4297 79.6359 11.8885 79.6359 11.245C79.6359 10.6911 79.7382 10.233 79.9427 9.87074C80.1473 9.50852 80.4264 9.21875 80.7801 9.00142C81.1338 8.78409 81.5322 8.62003 81.9754 8.50923C82.4229 8.39418 82.8852 8.31108 83.3625 8.25994C83.9378 8.20028 84.4044 8.14702 84.7623 8.10014C85.1203 8.04901 85.3802 7.9723 85.5422 7.87003C85.7084 7.76349 85.7915 7.59943 85.7915 7.37784V7.33949C85.7915 6.85795 85.6487 6.48509 85.3632 6.22088C85.0777 5.95668 84.6665 5.82457 84.1295 5.82457C83.5628 5.82457 83.1132 5.94815 82.7808 6.19531C82.4527 6.44247 82.2311 6.73437 82.116 7.07102L79.9555 6.7642C80.126 6.16761 80.4072 5.66903 80.7993 5.26847C81.1913 4.86364 81.6707 4.56108 82.2375 4.3608C82.8042 4.15625 83.4307 4.05398 84.1167 4.05398C84.5898 4.05398 85.0606 4.10938 85.5294 4.22017C85.9981 4.33097 86.4264 4.5142 86.8142 4.76989C87.202 5.02131 87.5131 5.36435 87.7474 5.79901C87.9861 6.23366 88.1054 6.77699 88.1054 7.42898V14H85.8809V12.6513H85.8042C85.6636 12.924 85.4655 13.1797 85.2098 13.4183C84.9584 13.6527 84.6409 13.8423 84.2574 13.9872C83.8781 14.1278 83.4328 14.1982 82.9214 14.1982ZM83.5223 12.4979C83.9868 12.4979 84.3895 12.4062 84.7304 12.223C85.0713 12.0355 85.3334 11.7884 85.5166 11.4815C85.7041 11.1747 85.7979 10.8402 85.7979 10.478V9.32102C85.7254 9.38068 85.6018 9.43608 85.4271 9.48722C85.2567 9.53835 85.0649 9.5831 84.8518 9.62145C84.6388 9.6598 84.4278 9.69389 84.219 9.72372C84.0102 9.75355 83.8291 9.77912 83.6757 9.80043C83.3305 9.8473 83.0216 9.92401 82.7488 10.0305C82.4761 10.1371 82.2609 10.2862 82.1032 10.478C81.9456 10.6655 81.8667 10.9084 81.8667 11.2067C81.8667 11.6328 82.0223 11.9545 82.3334 12.1719C82.6444 12.3892 83.0407 12.4979 83.5223 12.4979ZM90.4321 14V4.18182H92.746V14H90.4321ZM91.5954 2.78835C91.229 2.78835 90.9136 2.6669 90.6494 2.42401C90.3852 2.17685 90.2531 1.88068 90.2531 1.53551C90.2531 1.18608 90.3852 0.889914 90.6494 0.647016C90.9136 0.399857 91.229 0.276278 91.5954 0.276278C91.9662 0.276278 92.2815 0.399857 92.5415 0.647016C92.8057 0.889914 92.9378 1.18608 92.9378 1.53551C92.9378 1.88068 92.8057 2.17685 92.5415 2.42401C92.2815 2.6669 91.9662 2.78835 91.5954 2.78835ZM97.4394 0.909091V14H95.1254V0.909091H97.4394ZM107.579 6.77699L105.469 7.0071C105.41 6.79403 105.305 6.59375 105.156 6.40625C105.011 6.21875 104.815 6.06747 104.568 5.95241C104.321 5.83736 104.018 5.77983 103.66 5.77983C103.179 5.77983 102.774 5.88423 102.446 6.09304C102.122 6.30185 101.962 6.57244 101.967 6.90483C101.962 7.19034 102.067 7.42259 102.28 7.60156C102.497 7.78054 102.855 7.92756 103.354 8.04261L105.028 8.40057C105.957 8.60085 106.648 8.91832 107.099 9.35298C107.555 9.78764 107.785 10.3565 107.79 11.0597C107.785 11.6776 107.604 12.223 107.246 12.696C106.893 13.1648 106.4 13.5312 105.77 13.7955C105.139 14.0597 104.415 14.1918 103.597 14.1918C102.395 14.1918 101.427 13.9403 100.695 13.4375C99.9616 12.9304 99.5248 12.2251 99.3841 11.3217L101.641 11.1044C101.743 11.5476 101.96 11.8821 102.293 12.108C102.625 12.3338 103.057 12.4467 103.59 12.4467C104.14 12.4467 104.581 12.3338 104.913 12.108C105.25 11.8821 105.418 11.603 105.418 11.2706C105.418 10.9893 105.31 10.7571 105.092 10.5739C104.879 10.3906 104.547 10.25 104.095 10.152L102.42 9.80043C101.479 9.6044 100.782 9.27415 100.33 8.80966C99.8785 8.34091 99.6547 7.74858 99.659 7.03267C99.6547 6.42756 99.8188 5.90341 100.151 5.46023C100.488 5.01278 100.954 4.66761 101.551 4.42472C102.152 4.17756 102.844 4.05398 103.628 4.05398C104.779 4.05398 105.685 4.29901 106.345 4.78906C107.01 5.27912 107.421 5.94176 107.579 6.77699Z"
//         fill={color}
//       />
//     </svg>
//   );
// };
